import React from 'react'
import styled from 'styled-components'
import { GJLogo, LiveShopping } from './GJKit/newGJLogo'

export const Splash = () => {
  return (
    <Container>
      <LiveShopping />
      <GJLogo />
    </Container>
  )
}

const Container = styled.div`
  height: 100vh;
  height: 100dvh;
  display: flex;
  gap: 3rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
